import React from 'react';
import { SectionCta } from './SectionCta';
import { authorSearchList, authorSteps, authorStructure, images } from '../data/content';
export function Author() {
  return <section className="bg-sand px-4 py-16 sm:py-24" aria-labelledby="author-title" data-id="element-20" data-mp="9sx2mgqv1i69">
      <div className="mx-auto grid max-w-5xl gap-10 md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] md:items-start" data-id="element-21" data-mp="9r2eyuo7fbyh">
        <div className="md:sticky md:top-8" data-id="element-22" data-mp="12hkqmk2zulni">
          <img src={images.author} alt="Helena Duarte holding a singing bowl in her practice room" className="mx-auto aspect-[4/5] w-full max-w-sm rounded-3xl object-cover object-top shadow-xl md:max-w-none" data-id="element-23" data-mp="12ivv6m49jxfo" />
        </div>

        <div data-id="element-24" data-mp="xhye6cuzp9fr">
          <p className="text-sm font-bold uppercase tracking-wider text-brand-600" data-id="element-25" data-mp="xhokae6tqi4s">About the author</p>
          <h2 id="author-title" className="mt-2 font-serif text-[34px] font-bold leading-tight text-ink sm:text-5xl" data-id="element-26" data-mp="3d8kl8xobwaws">
            Hi, I’m Helena Duarte
          </h2>

          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-ink/85" data-id="element-27" data-mp="1tyah9jw3w9yd">
            <p data-id="element-28" data-mp="1u0eskmwc4b8o">
              For years, I studied different spiritual paths, energy practices, meditation and self-awareness tools.
            </p>
            <p data-id="element-29" data-mp="230bam5o7ybur">
              And for a long time, I made the same mistake I now see in so many people who become interested in Apometry:
            </p>
            <p className="font-serif text-2xl font-bold italic text-brand-800" data-id="element-30" data-mp="2cxg1git0evhw">
              I thought I needed to learn more before I could begin.
            </p>
            <p data-id="element-31" data-mp="27xtmo4xj976z">So I searched for…</p>
            <ul className="flex flex-wrap gap-2" data-id="element-32" data-mp="2lpqb9yzzsyym">
              {authorSearchList.map(s => <li key={s} className="rounded-full bg-white px-3 py-1 text-[15px] text-muted" data-id="element-33" data-mp="2ho4qzsl4piee">
                  {s}
                </li>)}
            </ul>
            <p data-id="element-34" data-mp="2vo765721xxpy">I accumulated information faster than I accumulated actual practice.</p>
            <p data-id="element-35" data-mp="2qqe3up3vdnuy">
              And whenever I wanted to sit down and practice, the same question appeared:{' '}
              <strong className="text-brand-800" data-id="element-36" data-mp="1od9g1m589imm">“What do I do now?”</strong>
            </p>
            <p data-id="element-37" data-mp="1sd9uh6sbttto">
              That question changed the way I approached my own practice. Instead of trying to learn everything first, I
              started creating simple structures.
            </p>
            <p className="rounded-2xl bg-brand-800 px-5 py-4 font-semibold text-white" data-id="element-38" data-mp="2244j2ht1p5ia">{authorStructure.join(' ')}</p>
            <p data-id="element-39" data-mp="2748ys5m4pw7g">
              Eventually, I realized something: <strong data-id="element-40" data-mp="2bzy46pkty7bo">people don’t always need more information.</strong> Sometimes they
              simply need a clear next step.
            </p>
            <p data-id="element-41" data-mp="2g0rshk26po53">
              That’s why I created the Apometry Practice Deck™ — not another endless course, not hundreds of pages of
              theory, not another library you save and forget.{' '}
              <strong data-id="element-42" data-mp="lqxrudcpyfft">A practical system you can open whenever you want to practice.</strong>
            </p>
            <ol className="grid grid-cols-2 gap-2 sm:grid-cols-3" data-id="element-43" data-mp="j458xkyvx770">
              {authorSteps.map(s => <li key={s} className="rounded-xl bg-white px-3 py-2 text-[15px] font-semibold text-brand-800" data-id="element-44" data-mp="edosdrzrp5gf">
                  {s}
                </li>)}
            </ol>
            <p data-id="element-45" data-mp="4f95k17rwicq">My goal is simple. I want you to finish your first practice and be able to say:</p>
            <p className="font-serif text-3xl font-bold italic text-brand-700" data-id="element-46" data-mp="122zm4pip9zl2">“Now I know what to do.”</p>
            <p className="font-serif text-lg font-semibold text-ink" data-id="element-47" data-mp="x469ezb8mcly">— Helena Duarte</p>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-5xl" data-id="element-48" data-mp="s3scacb6cn2p">
        <SectionCta label="I want to know what to do next" data-id="element-49" data-mp="s6wmprf8gf1t" />
      </div>
    </section>;
}